import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Breadcrumbs from "../../common/Breadcrumbs";
import Filtersearch from "../FilterSearch/FilterSearch";
import { useSearchParams } from "react-router-dom";

const OverdueEnrollments = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const crumbs = [
        { label: "Home", url: "/" },
        { label: "Overdue Enrollments", url: "/overdue-enrollments" },
    ];

    // Force the same defaults used by My Learning page
    useEffect(() => {
        const sort = searchParams.get("sort");
        const state = searchParams.get("filter.learnerState");
        if (sort !== "dueDate" || state !== "enrolled,started") {
            setSearchParams(
                { "filter.learnerState": "enrolled,started", sort: "dueDate" },
                { replace: true }
            );
        }
    }, [searchParams, setSearchParams]);

    return (
        <>
            <Breadcrumbs crumbs={crumbs} />

            <Container fluid className="pl-30 py-4">
                <div className="headerImage">
                    <h1>Overdue Enrollments</h1>
                </div>
            </Container>

            {/* Reuse My Learning filter + cards */}
            <Filtersearch myLearning={true} />
        </>
    );
};

export default OverdueEnrollments;